import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { navigate } from '@reach/router';
import {
  Grid,
  CardMedia,
  Toolbar,
  AppBar,
  IconButton,
  Container,
  Button,
  CircularProgress,
} from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { Link } from 'gatsby-theme-material-ui';
import PropTypes from 'prop-types';
import { auth } from '../../state';
import logoPath from '../../images/logo.png';
import LanguageSelect from '../custom/LanguageSelect/LanguageSelect';

const Header = ({ backArrow, href, logout, showHomePage, bgcolor }) => {
  const dispatch = useDispatch();
  const isLoggingOut = useSelector((state) =>
    auth.selectors.selectIsLoading(state)
  );

  const handleLogout = () => {
    dispatch(auth.actions.logout()).then(() => {
      navigate('/dashboard/login');
    });
  };

  return (
    <Container disableGutters>
      <AppBar
        component="header"
        position="sticky"
        elevation={0}
        style={{ backgroundColor: bgcolor }}
      >
        <Toolbar disableGutters>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} md={11}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  {backArrow ? (
                    <Link to={href}>
                      <IconButton aria-label="back">
                        <ArrowBack />
                      </IconButton>
                    </Link>
                  ) : (
                    showHomePage && (
                      <Grid container alignItems="center">
                        <Grid item xs={4} md={1}>
                          <Link to={href}>
                            <CardMedia
                              src={logoPath}
                              component="img"
                              alt="Pintuna logo"
                              style={{ width: '120px' }}
                            />
                          </Link>
                        </Grid>
                      </Grid>
                    )
                  )}
                </Grid>
                <Grid item>
                  <Grid container alignItems="center">
                    <Grid item>
                      <LanguageSelect />
                    </Grid>
                    {logout && (
                      <Grid item>
                        {isLoggingOut ? (
                          <CircularProgress />
                        ) : (
                          <Button onClick={handleLogout}>Logout</Button>
                        )}
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </Container>
  );
};

Header.defaultProps = {
  backArrow: false,
  href: '/',
  logout: false,
  showHomePage: true,
  bgcolor: '#fff',
};

Header.propTypes = {
  backArrow: PropTypes.bool,
  href: PropTypes.string,
  logout: PropTypes.bool,
  showHomePage: PropTypes.bool,
  bgcolor: PropTypes.string,
};

export default Header;
